const tabbedContentInit = () => {
    const desktopWidth = 1024;
    let isDesktop = window.innerWidth >= desktopWidth;

    const handleResize = () => {
        isDesktop = window.innerWidth >= desktopWidth;
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('DOMContentLoaded', () => {
        const mainPattern = document.querySelectorAll('.gg-tabbed');
        mainPattern.forEach((module) => {
            const headers = module.querySelectorAll('.wp-block-statik-accordion-item__header');
            const imageAcco = module.querySelector('.gg-image-acc');
            const headersExpand = module.querySelector('.wp-block-statik-accordion-item--expanded .wp-block-statik-accordion-item__header');
            let height = 0;
            
            if (isDesktop) {
                headers.forEach((header, index) => {
                    const parent = header.parentElement;
                    let  image = parent.querySelector('figure');
                    if ( image == null) {
                        image = document.createElement('figure');
                        image.className = 'wp-block-image size-large';
                        parent.appendChild(image);
                    }
                    if (image) {
                        const clonedImage = image.cloneNode(true);
                        clonedImage.id = header.id + '-imageclone';
                        clonedImage.classList.add('fade-in-up');
                        imageAcco.appendChild(clonedImage); 
                        const clonedImageHeight = clonedImage.offsetHeight;
                        if (clonedImageHeight > height) {
                            height = clonedImageHeight;
                        }
                        if (index !== 0) {
                            const imgClone = clonedImage.querySelector('img');
                            imgClone.style.opacity = '0';
                            
                        }

                        if (headersExpand) {
                            const targetIdExpand = headersExpand.id + '-imageclone';
                            const targetImageExpand = imageAcco.querySelector(`#${targetIdExpand} img`);
                
                            if (targetImageExpand) {
                                height = targetImageExpand.offsetHeight + 48;
                                imageAcco.style.height = `${height}px`;
                            }
                        }
                        header.addEventListener('click', () => {
                            const clonedImages = imageAcco.querySelectorAll('figure');
                            const imageItemsSize = imageAcco.querySelectorAll('.size-large')
                            imageItemsSize.forEach((item) => {
                                item.style.opacity = '0';
                            });
                            clonedImages.forEach((clonedImg) => {
                                const imgClone = clonedImg.querySelector('img');
                                imgClone.style.opacity = '0';
                                imgClone.classList.remove('fade-in-up');
                            });
                            const targetId = header.id + '-imageclone';
                            const targetImage = imageAcco.querySelector(`#${targetId} img`);
                            if (targetImage) {
                                targetImage.style.opacity = '1';
                                targetImage.classList.add('fade-in-up');
                                height = targetImage.offsetHeight + 48;
                                imageAcco.style.height = `${height}px`;
                            }

                        });
                    }
                });
            }
        });
    });
};

tabbedContentInit();
